<template>
  <div class="gmf-comment gmf-comment-reply-form" :class="{'gmf-comment-reply': depth > 0, 'gmf-comment-final': finalNode}">
    <div class="gmf-comment-indent"
      v-for="i in depth"
      :key="i"
      :class="{
        'gmf-comment-indent-nested': i > 1,
        'gmf-comment-branch': parentBranches && parentBranches[i-1],
        'gmf-comment-leaf': i === depth,
      }"
    />
    <div class="gmf-comment-customer-col">
      <Avatar class="gmf-comment-avatar" :customer="profile" :disableOnlineIndicator="true" :disablePopup="true" />
    </div>
    <div class="gmf-comment-content-col">
      <div class="gmf-comment-content">
        <div class="gmf-comment-body">
          <div v-if="hasSent" class="gmf-comment-reply-form-sent">
            {{t('thanks_for_answer')}}
          </div>
          <template v-else>
            <div class="gmf-alert gmf-alert-warn" v-if="t('reply_disclaimer.' + commentType)">
              {{ t('reply_disclaimer.' + commentType) }}
            </div>
            <!--<div class="gmf-comment-reply-form-header">{{t('my_answer')}}:</div>-->
            <TextArea v-model="text" :rows="1" :placeholder="t('write_answer')" />
            <CommentCharCounter :text="text" :maxChars="maxReplyLength" />
            <div v-if="error" class="gmf-comment-reply-form-error" v-text="error.message"></div>
            <button class="gmf-btn gmf-btn-sm gmf-btn-primary" @click="send">{{t('send')}}</button>
            <div class="gmf-loading" v-if="isSending"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.gmf-comment-reply-form .gmf-comment-content {
  width: 100%;
  max-width: 650px;
}
.gmf-comment-reply-form textarea {
  border: 1px solid var(--gmf-col-gray) !important;
  outline: none !important;
  background: white;
  color: var(--gmf-col-nearblack);
  padding: 8px 12px;
  display: block;
  width: 100%;
  resize: none;
  overflow: hidden;
  border-radius: var(--gmf-rounding);
  font-size: 13px;
  font-family: unset;
}
.gmf-comment-reply-form .gmf-comment-body {
  flex-direction: column;
  align-items: flex-end;
  gap: 0px;
}
.gmf-comment-reply-form .gmf-comment-body::after {
  top: 32px;
}
.gmf-comment-reply-form textarea::placeholder {
  color: var(--gmf-col-darkgray);
}
.gmf-comment-reply-form textarea:focus {
  outline: none !important;
  border: 1px solid var(--gmf-col-gray) !important;
}
.gmf-comment-reply-form-header {
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 8px;
  align-self: flex-start;
}

.gmf-comment-reply-form .gmf-btn {
  display: inline-block;
  margin-top: 12px;
}

.gmf-comment-reply-form .gmf-loading {
  position: absolute;
  inset: 0;
  background-color: rgba(10,10,10,.1);
  height: 100%;
  margin: 0;
  border-radius: var(--gmf-rounding);
  background-size: 80px;
}

.gmf-comment-reply-form-error {
  color: var(--gmf-col-error);
  font-size: 13px;
  margin-top: 4px;
}
.gmf-comment-reply-form-sent {
  font-style: italic;
  color: var(--gmf-col-darkgray);
}
.gmf-comment-reply-form .gmf-alert {
  align-self: stretch;
}
</style>

<script>
import postComment from '@/utils/postComment';
import CommentCharCounter from '@/components/CommentForm/CommentCharCounter';
import TextArea from '@/components/input/TextArea.vue';
import Avatar from '@/components/Avatar';
import state from '@/state';

const t = state.t.prefix('comments');


export default {
  props: ['depth', 'finalNode', 'parentBranches', 'commentType', 'targetId', 'parentId'],
  components: {
    CommentCharCounter,
    TextArea,
    Avatar,
  },
  data () {
    return {
      state,

      text: '',

      isSending: false,
      hasSent: false,

      error: null,
    };
  },
  computed: {
    avatarUrl () {
      if (this.profile && this.profile.avatarUrl) {
        return this.profile.avatarUrl;
      }
      if (this.profile && this.profile.avatarCode) { // @deprecated
        return this.state.cdnBase + '/v1/avatar/render/' + this.profile.avatarCode;
      }
      return this.state.merchantConfig.avatars.placeholderImage;
    },
    maxReplyLength () {
      let c = (this.state.merchantConfig?.comments) || {};
      return c[this.commentType]?.maxTextLength || 1000;
    },
    profile() {
      return this.state.profile;
    }
  },
  methods: {
    t,
    async send () {
      if (this.isSending)
      this.isSending = true;


      const { error } = await postComment(this.commentType, this.targetId, {
        parentId: this.parentId,
        text: this.text,
      });

      this.isSending = false;
      this.error = error;
      this.hasSent = ! error;
    },
  },
};
</script>
